import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[click]'
})
export class CursorPointerDirective {

  @HostBinding('style.cursor') cursor: string = 'pointer';

}
